import { Flex, Modal, Select } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import { lang } from './lang'
import Option from './Option'
import { ITTSVoice, IVoice } from '@/pages/Donation/api/streamer/types'
import Header from '@/pages/Donation/components/SelectModal/Header'

type Props = {
  isOpen: boolean
  onClose: () => void
  options: ITTSVoice[]
  selectedVoice: IVoice
  onSelectVoice: (voice: IVoice) => void
}

export default function VoiceSelect({ isOpen, onClose, options, selectedVoice, onSelectVoice }: Props) {
  const languages = options.map(option => ({ value: option.language, label: option.language }))
  const [language, setLanguage] = useState(languages[0]?.value)

  const { voices: languageVoices = [] } = options.find(option => option.language === language) ?? {}

  return (
    <Modal open={isOpen} footer={false} onCancel={onClose} width={408} destroyOnClose>
      <Flex vertical gap={16}>
        <Header title={<FormattedMessage {...lang.title} />} subtitle={<FormattedMessage {...lang.subtitle} />} />
        <Select options={languages} value={language} onSelect={setLanguage} />
        {languageVoices.map((voice, index) => (
          <Option
            key={index}
            voice={voice}
            onOptionClick={() => onSelectVoice(voice)}
            isSelected={selectedVoice?.name === voice.name}
          />
        ))}
      </Flex>
    </Modal>
  )
}
